<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M4.16667 13.5352C3.16168 12.8625 2.5 11.7168 2.5 10.4167C2.5 8.46369 3.99292 6.85941 5.89978 6.68281C6.28985 4.31011 8.3502 2.5 10.8333 2.5C13.3165 2.5 15.3768 4.31011 15.7669 6.68281C17.6737 6.85941 19.1667 8.46369 19.1667 10.4167C19.1667 11.7168 18.505 12.8625 17.5 13.5352M7.5 14.1667L10.8333 17.5M10.8333 17.5L14.1667 14.1667M10.8333 17.5V10"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
